import { OperationValidationErrors } from '../../../components/operationErrors/OperationValidationErrors'
import { useTemplateContext } from '../../../context/templateContext'
import { isGeneralTemplateError } from './helpers'

/**
 * Validation errors of the template version in scope that are not tied to one of its
 * fields.
 */
export const GeneralTemplateOperationErrors = () => {
  const { templateVersion } = useTemplateContext()

  return (
    <OperationValidationErrors
      operationKey={templateVersion?.versionInfo.operationKey}
      errorFilter={isGeneralTemplateError(
        templateVersion?.versionInfo.identifier,
      )}
      padding="condensed"
    />
  )
}
